import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "app/slice/selectors";

import { Button } from "app/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "app/components/ui/dialog";

const activateOptions = [
  {
    icon: "/assets/active-customer-avatar.svg",
    altText: "Active Customer",
    title: "Do you have an active account with us?",
    description: "You will be taken to your dashboard to complete activation.",
  },
  {
    icon: "/assets/new-customer-avatar.svg",
    altText: "New Customer",
    title: "Are you a new customer?",
    description: "Great! Chose this option to start your journey.",
  },
  // {
  //   icon: "/assets/phone-office.svg",
  //   altText: "Phone Office",
  //   title: "Activate Home Phone Base",
  //   description: "Choose this option if you purchased a base from a reseller",
  // },
];

export const ActivateDialog = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedOptionTitle, setSelectedOptionTitle] = useState<string | null>(null);
  const user = useSelector(selectUser);

  const handleContinue = () => {
    if (selectedOptionTitle === activateOptions[0].title) {
      (user ? window.location.href = "/my-account/dashboard" : window.location.href = "/login");
    } else {
      if (selectedOptionTitle === activateOptions[2].title) {
        window.location.href = "/home-phone";
      } else {
        window.location.href = "/network-plan";
      }
    }
    setShowDialog(false);
  };

  return (
    <Dialog
      open={showDialog}
      onOpenChange={(open) => {
        setShowDialog(open);
        if (!open) {
          setSelectedOptionTitle(null);
        }
      }}
    >
      <Button
        type="button"
        variant="ghost"
        className={`lg:hidden justify-between hover:bg-transparent w-full text-sm leading-[1.8125rem] hover:text-[#FE4D01] ${
          showDialog ? "text-[#1D1D1B] font-semibold" : "text-[#464646] font-medium"
          }`}
        onClick={() => setShowDialog(true)}
      >
        Activate
        <img src="/assets/chevron-down.svg" alt="Chevron Down" className="-rotate-90 size-5 shrink-0" aria-hidden="true" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        className={`hidden lg:inline-flex hover:bg-transparent text-xs sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-[1.125rem] lg:leading-5 hover:text-[#FE4D01] whitespace-nowrap ${
            showDialog
              ? "text-[#1D1D1B]"
              : "text-[#464646]"
        }`}
        onClick={() => setShowDialog(true)}
      >
        Activate
      </Button>
      <DialogContent
        className="reltive top-[45%] gap-0 bg-white w-[95%] sm:max-w-[34.125rem] p-4 pt-3 sm:p-5 sm:pt-[0.8125rem] lg:p-6 lg:pt-[0.875rem] text-center"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogClose className="absolute top-3.5 md:top-4 right-5 md:right-6 rounded-full">
          <img
            src="/assets/close-circle.webp"
            className="flex-shrink-0 w-5 h-5 rounded-full opacity-90 md:w-6 md:h-6 hover:opacity-100"
            alt="Close"
          />
        </DialogClose>
        <DialogHeader className="p-0 bg-transparent text-left mb-3.5 sm:mb-4 lg:mb-[1.125rem]">
          <DialogTitle className="max-w-[90%] font-mobile text-black text-lg sm:text-xl lg:text-2xl font-bold leading-6 sm:leading-7 tracking-[-0.015rem]">
            Make a selection to proceed
          </DialogTitle>
        </DialogHeader>
        <ul className="space-y-3.5 sm:space-y-4 lg:space-y-5 mb-3.5 sm:mb-4 lg:mb-5">
          {activateOptions.map((option, index) => (
            <li
              key={index}
              className={`flex items-center gap-2.5 p-2 sm:p-2.5 rounded-2xl md:rounded-[1.125rem] ${selectedOptionTitle === option.title ? "bg-[#FE4D0114] border border-[#FE4D0166] transition-all duration-300" : "bg-[#F9F9F9] hover:bg-[#FE4D010D]"} cursor-pointer`}
              onClick={() => {
                setSelectedOptionTitle(option.title);
              }}
            >
              <div className={`shrink-0 flex-grow-0 flex justify-center items-center ${selectedOptionTitle === option.title ? "bg-white transition-all duration-300 " : "bg-[#EAEAEA]"} size-[3.75rem] sm:size-16 lg:size-[4.25rem] rounded-2xl md:rounded-[1.125rem]`}>
                <img src={option.icon} alt={option.altText} className="size-[1.625rem] sm:size-7 lg:size-[1.875rem]" />
              </div>
              <div className="text-left">
                <h4 className={`font-mobile text-black text-sm sm:text-[0.925rem] lg:text-base font-bold leading-6 sm:leading-[1.625rem] lg:leading-7 ${selectedOptionTitle === option.title ? "capitalize transition-all duration-300" : ""}`}>
                  {option.title}
                </h4>
                <p className="text-black/50 text-[0.72rem] sm:text-xs font-medium leading-[1.125rem] sm:leading-5">
                  {option.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
        <Button
          type="button"
          variant="primary"
          disabled={!selectedOptionTitle}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </DialogContent>
    </Dialog>
  );
};
